/** API endpoint definitions. */

export const API_ENDPOINTS = {
  dashboard: '/api/v1/dashboard',
  dashboardHypeScore: '/api/v1/dashboard/hype_score',
  liveFeed: '/api/v1/live_feed',
  influencers: '/api/v1/influencers',
  dueDiligence: '/api/v1/due_diligence',
  dueDiligencePostContent: '/api/v1/due_diligence/post_content',
  deepDive: (ticker: string) => `/api/v1/deep_dive/${ticker}`,
  deepDiveFundamentals: (ticker: string) => `/api/v1/deep_dive/fundamentals/${ticker}`,
  deepDiveHistoricalPrice: (ticker: string) => `/api/v1/deep_dive/historical_price/${ticker}`,
  influencerDeepDive: (author: string, window?: string) => {
    const base = `/api/v1/influencers/${encodeURIComponent(author)}`;
    if (window) {
      return `${base}?window=${encodeURIComponent(window)}`;
    }
    return base;
  },
  news: '/api/v1/news',
  statusUptime: '/api/v1/status/uptime',
  stockPrices: '/api/v1/stock_prices',
} as const;

